import { DocumentNode, useMutation } from '@apollo/client';
import {
  Actions,
  AppArea,
  CreateUserMergeRequestDocument,
  CreateUserMergeRequestDto,
  CreateUserProfileMergeRequestDocument,
  Subjects,
  UserMergeRequestDocument,
} from 'src/graphql/generated/graphql';
import { useCan } from 'src/utils/can';

export const useUserMergeRequestCreate = (refetchQueries?: DocumentNode[]) => {
  const { can } = useCan();

  const canWriteAsAdmin = can({
    action: Actions.Write,
    subject: Subjects.UserMergeRequests,
    appArea: AppArea.Admin,
  });

  const document = canWriteAsAdmin
    ? CreateUserMergeRequestDocument
    : CreateUserProfileMergeRequestDocument;

  return useMutation(document, {
    refetchQueries: refetchQueries || [UserMergeRequestDocument],
  });
};
